import type { Matrix } from "#public"

/** The transform that moves nothing, in whatever space the caller works in.
 *
 * A function rather than a constant because the translation carries a unit and
 * a zero has to be a zero *of that unit*. */
export const MatrixIdentity = <T extends number>(): Matrix<T> => [1, 0, 0, 1, 0 as T, 0 as T]
